var ScrollBoxInit;

(function ($) {

	const selectors = {
		box: '[data-scroll-box]'
	}

	var winData = {
		height: $(window).height()
	}

	ScrollBoxInit = class ScrollBoxInit {
		constructor() {
			this.init();
		}
		init() {
			$(selectors.box).each((i, el) => {
				new ScrollBox(el);
			})
		}
	}

	class ScrollBox {
		constructor(element) {
			this.box = element;

			this.init();
			this.resize();
			this.bind();

			// console.log(this);

		}
		init() {

			var w = $(this.box).attr('data-width') ? $(this.box).attr('data-width') : $(this.box).outerWidth();

			if (w.indexOf('vw') != -1) {
				w = w.replace('vw', '');
				w = (parseFloat(w) / 100) * $(window).width();
			}

			w = parseFloat(w);

			this.width = w;
			this.offset = this.width - $(this.box).parent().width();

		}
		bind() {

			// const throttledScroll = throttle(30, false, () => {
			// 	this.scroll();
			// });

			$(document).ready((e) => { this.resize(); });
			$(window).resize((e) => { this.resize(); });
			// $(window).scroll( (e) => { throttledScroll(); } );
			$(window).scroll((e) => { this.scroll(); });

		}
		resize() {
			$(this.box).width(this.width);

			this.offTop = $(this.box).offset().top;
			this.height = $(this.box).outerHeight();
			winData.height = $(window).height();

			this.scroll();
		}

		scroll() {

			// var time = window.performance.now();
			// console.log(time);

			// var perc = ( $(window).scrollTop() + winData.height*0.75 - this.offTop ) / ( this.height );
			// var perc = ( $(window).scrollTop() + winData.height/2 - this.offTop ) / ( this.height );
			var perc = ($(window).scrollTop() + winData.height * 0.9 - this.offTop) / (this.height);
			var new_off = -(perc * this.offset);

			$(this.box).css('transform', 'translateX(' + new_off + 'px)');

			// console.log(window.performance.now() - time);

		}

	}

})(jQuery);


export default ScrollBoxInit;